import { useEffect, useState } from 'react';

import { PRODUCT_CATEGORY_URL_PARAM } from '~constants';
import { useProductCategoryResolver } from '~hooks';
import { ProductDetails } from '~organisms';
import { ProductList } from '~widgets';

enum PageToRender {
  List = 'LIST',
  Details = 'DETAILS',
}

/**
 * @deprecated This widget will be rewritten entirely. Do not use for new features.
 *
 * Renders product list or product details page, depending on the URL parameter 'prodcat'.
 */
export const ProductExplorer = () => {
  const [widgetToDisplay, setWidgetToDisplay] = useState(PageToRender.List);

  const searchParams = new URL(globalThis.location.href).searchParams;
  const productCategoryShortname = searchParams.get(PRODUCT_CATEGORY_URL_PARAM) ?? undefined;

  const { productCategory, products, loading } = useProductCategoryResolver({
    productCategoryShortname,
    propagateErrors: true,
  });

  useEffect(() => {
    const urlParams = globalThis.location.search;

    if (urlParams.includes(`${PRODUCT_CATEGORY_URL_PARAM}=`)) {
      setWidgetToDisplay(PageToRender.Details);
    }

    const handlePopstate = (event: PopStateEvent) => {
      const url: string = event.state ? event.state.path : globalThis.location.search;
      if (url !== undefined && !url.includes(`${PRODUCT_CATEGORY_URL_PARAM}=`)) {
        setWidgetToDisplay(PageToRender.List);
      }
    };

    globalThis.addEventListener('popstate', handlePopstate);

    return () => {
      globalThis.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  const handleBackToResultsButtonClick = () => {
    const url = new URL(globalThis.location.href);
    url.searchParams.delete(PRODUCT_CATEGORY_URL_PARAM);
    globalThis.history.pushState({}, '', url.href);
    setWidgetToDisplay(PageToRender.List);
  };

  const handleDiscoverButtonClick = (productCategoryShortname: string) => {
    const url = new URL(globalThis.location.href);
    url.searchParams.set(PRODUCT_CATEGORY_URL_PARAM, productCategoryShortname);
    globalThis.history.pushState({}, '', url.href);
    setWidgetToDisplay(PageToRender.Details);
  };

  if (widgetToDisplay === PageToRender.Details) {
    return (
      <ProductDetails
        productCategory={productCategory}
        products={products}
        isLoadingProductCategory={loading}
        onBackButtonClick={handleBackToResultsButtonClick}
      />
    );
  }

  return <ProductList onDiscoverButtonClick={handleDiscoverButtonClick} />;
};
